export default {
  closeButtonBorderRadius: 'xLarge',
  popupBorderRadius: 'xLarge',
  overlayColor: '0, 0, 0, 0.7',
  includeFooterDivider: false,
  buttonVariant: 'primary',
  styleScrollbars: true,
  closeCtaSize: '48px',
};
